
    const ReadConfigHelper = (setConfigFunc) => {
        
      fetch('/config.json')
      .then(response => response.json())
      .then(data => setConfigFunc(
        data));
       
    }
    
    export default ReadConfigHelper
